interface SvgProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export default function ImageIcon(props: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      width={41.109}
      height={41.109}
      viewBox="0 0 41.109 41.109"
      {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        data-name="Icon material-photo"
        d="M41.109 36.541V4.568A4.581 4.581 0 0036.541 0H4.568A4.581 4.581 0 000 4.568v31.973a4.581 4.581 0 004.568 4.568h31.973a4.581 4.581 0 004.568-4.568zM12.561 23.98l5.71 6.874 7.993-10.3 10.277 13.7H4.568z"
      />
    </svg>
  )
}
